

































































import { computed, defineComponent, getCurrentInstance, reactive, watch, ref, nextTick } from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';
import InviteSetting from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/InviteSetting.vue';
import SpaceConfig from '@/renderer/views/desktop/ManageConsole/UserManagement/components/spaceConfig.vue';
import InviteQrcode from '@/renderer/components/Qrcode/components/InviteQrcode.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import inviteMembersHandler, {
  GenerateCodeStatus,
} from '@/renderer/views/desktop/ManageConsole/UserManagement/externalUser/compositions/inviteExtMemberHandler';

// 引入工具类
import { SMH } from '@/renderer/scripts/smh';
const QRCode = require('qrcode');
interface Props {
  show: boolean;
  group: SMH.ColleborationSpaceInfoData;
}
export default defineComponent({
  name: 'InviteExtDialog',
  components: {
    InviteSetting,
    SpaceConfig,
    ChevronLeftIcon,
    InviteQrcode,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true,
    },
  },
  filters: {
    buttonTheme(val: GenerateCodeStatus, isLable: boolean) {
      if (val === GenerateCodeStatus.IS_START) {
        return isLable ? i18n_t('停止分享') : 'danger';
      }
      return isLable ? i18n_t('恢复') : 'success';
    },
  },
  setup(props: Props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const defaultRoleId = computed(() => vm.$store.getters.defaultRoleId);
    const showDialog = reactive({
      addMembers: false,
      inviteSetting: false,
    });
    const { loadingUrlInfo, inviteUrlInfo, methods: inviteMemberMethods } = inviteMembersHandler();
    const codeStatus = computed(() => inviteUrlInfo.codeStatus);
    const spaceEditing = ref(false); // 正在设置空间

    const methods = {
      initDialog() {
        spaceEditing.value = false;
      },
      renderRoleId(id: number) {
        const roles = vm.$store.getters.roles as Array<{
          id: number;
          name: string;
        }>;
        return roles.find(role => role.id === id)?.name || i18n_t('观察者');
      },
      toggleAddDialog(val: boolean) {
        showDialog.addMembers = val;
      },
      toggleSettingDialog(val: boolean) {
        showDialog.inviteSetting = val;
      },
      changeUrlStatus() {
        const type = codeStatus.value === GenerateCodeStatus.IS_START ? 'stop' : 'recovery';
        inviteMemberMethods.updateInviteCodeInfo(type);
      },
      changeInviteSetting(key: string, value: boolean | number) {
        const params: Record<string, any> = {};
        params[key] = value;
        inviteMemberMethods.updateInviteCodeInfo(undefined, params);
      },
    };
    watch(innerShow, val => {
      if (val) {
        inviteMemberMethods.initData();
        methods.initDialog();
      }
    });
    return {
      innerShow,
      showDialog,
      defaultRoleId,
      ...methods,
      loadingUrlInfo,
      codeStatus,
      inviteUrlInfo,
      spaceEditing,
      inviteMemberMethods,
    };
  },
});
